import { makeStyles } from "@material-ui/core";

const useRbSwipeViewStyles = makeStyles({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  wrap: (props) => ({
    display: "flex",
    position: "relative",
    width: `${props.childrenCount * 100}%`,
    height: "100%",
  }),
});

export default useRbSwipeViewStyles;
